import { TagModalService } from '@app/tags/services/tag-modal.service';
import { DIALOG_DATA } from '@angular/cdk/dialog';
import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  signal,
} from '@angular/core';
import { TagsApi } from '@app/tags/tag-api.model';
import {
  AvatarComponent,
  AvatarSize,
  DialogService,
} from '@degreed/apollo-angular';
import { TagRatingDonutComponent } from '../tag-rating-donut/tag-rating-donut.component';
import { PrettyTimeElapsedPipe } from '@app/shared/pipes/pretty-time-elapsed.pipe';
import { TranslateService } from '@ngx-translate/core';
import { TranslateFn, translateWithDefaults } from '@app/shared/utils';
import { AssociateRatingModalActions } from '../tag-completed-associate-rating-modal/tag-completed-associate-rating-modal.component';
import { PeerRatingOverviewModalV3Component } from '../peer-rating-overview-modal-v3/peer-rating-overview-modal-v3.component';

@Component({
    selector: 'dgx-tag-completed-associate-rating-modal-v3',
    imports: [AvatarComponent, TagRatingDonutComponent, PrettyTimeElapsedPipe],
    templateUrl: './tag-completed-associate-rating-modal-v3.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TagCompletedAssociateRatingModalV3Component {
  public translate: TranslateFn = translateWithDefaults(this.translateService);
  public avatarSize = AvatarSize.ExtraLarge;
  public ratingInfo = signal<Partial<TagsApi.UserTagRatingDetails>>(
    this.data.ratingInfo
  );
  public allowRatingRequest = signal<boolean>(this.data.allowRatingRequest);

  constructor(
    private translateService: TranslateService,
    private dialogService: DialogService,
    private tagModalService: TagModalService,
    @Inject(DIALOG_DATA)
    public data: {
      ratingInfo: Partial<TagsApi.UserTagRatingDetails>;
      allowRatingRequest: boolean;
    }
  ) {}

  public cancel(): void {
    this.updateLastModalInstance();
    this.dialogService.close(TagCompletedAssociateRatingModalV3Component);
  }

  public onViewLevelDescriptions(event: Event): void {
    this.updateLastModalInstance();
    this.dialogService.close(TagCompletedAssociateRatingModalV3Component, {
      action: AssociateRatingModalActions.ViewLevelDescriptions,
      event,
    });
  }

  public onViewTagDetails(event: Event): void {
    this.updateLastModalInstance();
    this.dialogService.close(TagCompletedAssociateRatingModalV3Component, {
      action: AssociateRatingModalActions.ViewTagDetails,
      event,
    });
  }

  public onRequestNewRating(event: Event): void {
    this.dialogService.close(TagCompletedAssociateRatingModalV3Component, {
      action: AssociateRatingModalActions.RequestNewRating,
      event,
    });
    this.dialogService.close(PeerRatingOverviewModalV3Component);
  }

  private updateLastModalInstance(): void {
    if (this.tagModalService.dialogStack.length) {
      this.tagModalService.dialogStack.pop();
    }
  }
}
